import { createContext, useContext } from "react";
import { ComponentType } from "@growth-machine-llc/stridist-api-client";
import { AllOptionType } from "../constants";
import { BaseLibraryFilterContextValues } from "../wrappers/router/coach/CoachLibraryLayout";

export interface ComponentTemplateListFilterContextValues
  extends BaseLibraryFilterContextValues {
  templateType: ComponentType[] | AllOptionType;
  handleComponentTemplateTypeChange: (
    type: ComponentType[] | AllOptionType,
  ) => void;
}

export const ComponentTemplateListFilterContext = createContext<
  ComponentTemplateListFilterContextValues | undefined
>(undefined);

export const useComponentTemplateListFilterContext = () => {
  const context = useContext(ComponentTemplateListFilterContext);
  if (context === undefined) {
    throw new Error(
      "ComponentTemplateListFilterContext must be used within a ComponentTemplateListFilterProvider",
    );
  }
  return context;
};
